import React, { useState } from 'react';
import { Box, Typography, Container, IconButton } from '@mui/material';
import { InfoOutlined, Close } from '@mui/icons-material';

import { colors } from '../../theme';

interface IDowntimeBannerProps {
  message?: string;
}

/**
 * DowntimeBanner Component
 * Header banner showing scheduled downtime notification
 */
const DowntimeBanner: React.FC<IDowntimeBannerProps> = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleCloseBanner = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Box
      sx={{
        background: `linear-gradient(90deg, ${colors.primary}, ${colors.secondary})`,
        padding: '12px 0',
        borderBottom: `2px solid ${colors.primary}`,
        boxShadow: `0 2px 8px ${colors.primary}30`,
        position: 'relative',
        zIndex: 1300,
        marginTop: '-16px',
      }}
    >
      <Container maxWidth={false}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            px: { xs: 2, sm: 3 },
          }}
        >
          {/* Icon and text */}
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}
          >
            <InfoOutlined
              sx={{
                color: 'white',
                fontSize: '20px',
                flexShrink: 0,
              }}
            />
            <Typography
              variant="body2"
              sx={{
                color: 'white',
                fontWeight: 500,
                fontSize: '14px',
              }}
            >
              {process.env.REACT_APP_DOWNTIME_MESSAGE ||
                'We are performing scheduled maintenance. Some features may be temporarily unavailable.'}
            </Typography>
          </Box>

          {/* Close button */}
          <IconButton
            onClick={handleCloseBanner}
            size="small"
            sx={{
              color: 'white',
              flexShrink: 0,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
            aria-label="close banner"
          >
            <Close sx={{ fontSize: '20px' }} />
          </IconButton>
        </Box>
      </Container>
    </Box>
  );
};

export default DowntimeBanner;
